import React from 'react';
import { connect } from 'react-redux';
import { DBDecimalFieldObjective, ObjectiveFlag } from '_components';
import styles from './Common.module.css'

class ObservationCircumferencePIP extends React.Component {

    render() {
        return (
            <div>
                <div className={styles.row}>
                    <ObjectiveFlag className={styles.flag} flagged={this.props.flagged} mopno={this.props.mopno} flagText='Circumference - PIP' />
                    <label className={styles.label}>PIP</label>
                </div>
                <div className={styles.textfield_row}>
                    <span className={styles.flag} />
                    <label className={styles.sublabel_indent}>Index</label>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRPIPINDEXR'
                            className={styles.circum_input}
                            min={0}
                        />
                    </span>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRPIPINDEXL'
                            className={styles.circum_input}
                            min={0}
                        />
                    </span>
                </div>
                <div className={styles.textfield_row}>
                    <span className={styles.flag} />
                    <label className={styles.sublabel_indent}>Middle</label>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRPIPMIDDLER'
                            className={styles.circum_input}
                            min={0}
                        />
                    </span>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRPIPMIDDLEL'
                            className={styles.circum_input}
                            min={0}
                        />
                    </span>
                </div>
                <div className={styles.textfield_row}>
                    <span className={styles.flag} />
                    <label className={styles.sublabel_indent}>Ring</label>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRPIPRINGR'
                            className={styles.circum_input}
                            min={0}
                        />
                    </span>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRPIPRINGL'
                            className={styles.circum_input}
                            min={0}
                        />
                    </span>
                </div>
                <div className={styles.textfield_row}>
                    <span className={styles.flag} />
                    <label className={styles.sublabel_indent}>Small</label>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRPIPSMALLR'
                            className={styles.circum_input}
                            min={0}
                        />
                    </span>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRPIPSMALLL'
                            className={styles.circum_input}
                            min={0}
                        />
                    </span>
                </div>

            </div>
        );
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let oono = parseInt(Object.keys(state.entities.notes.PTOBJECTIVEOBS)
        .find(key => (state.entities.notes.PTOBJECTIVEOBS[key].OOEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVEOBS[key].OONTNO === pk && noteType !== 1)));

    return {
        noteId: noteId,
        oono: oono,
        flagged:
            (state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRPIPINDEXR !== undefined && state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRPIPINDEXR !== null)
                || (state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRPIPINDEXL !== undefined && state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRPIPINDEXL !== null)
                || (state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRPIPMIDDLER !== undefined && state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRPIPMIDDLER !== null)
                || (state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRPIPMIDDLEL !== undefined && state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRPIPMIDDLEL !== null)
                || (state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRPIPRINGR !== undefined && state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRPIPRINGR !== null)
                || (state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRPIPRINGL !== undefined && state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRPIPRINGL !== null)
                || (state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRPIPSMALLR !== undefined && state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRPIPSMALLR !== null)
                || (state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRPIPSMALLL !== undefined && state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRPIPSMALLL !== null)
                ? true : false
    };
}

const connectedObservationCircumferencePIP = connect(mapStateToProps)(ObservationCircumferencePIP);
export { connectedObservationCircumferencePIP as ObservationCircumferencePIP };


